<template>
  <div class="list-view" v-if="!isLoading" ref="wrapper" v-on-display="{sectionInfo, context: this}">
    <div>
      <div class="list-sub-menu">
        <div class="title">
          <h1 v-html="title" tabindex="0"></h1>
        </div>
        <div class="filter-wrap" v-if="filter !== null">
          <FilterList :filter="filter" />
        </div>
      </div>
    <div class="list-view-detail">
      <div class="live-ui" v-for="(row, rowIndex) in cellList" :key="'wrapper_' + rowIndex">
        <template v-if="isLandscapePlayerCell">
          <LandscapePlayerCell
            v-for="(cell, colIndex) in row"
            :key="'list_cell_' + rowIndex + '_' + colIndex"
            :is="thumbnailInfo.componentName"
            :cell-info="cell"
            :isPlayerMute="isPlayerMute"
            :setPlayerMuteStateFn="setPlayerMuteState"
            :thumbnail-info="thumbnailInfo"
          />
        </template>

        <template v-else>
          <navigation-cell-wrapper
            v-for="(cell, colIndex) in row"
            :key="'list_cell_' + rowIndex + '_' + colIndex"
            :cell-info="cell"
          >
            <template #clickable-cell>
              <component
                :is="thumbnailInfo.componentName"
                :cell-info="cell"
                :isPlayerMute="isPlayerMute"
                :setPlayerMuteStateFn="setPlayerMuteState"
                :thumbnail-info="thumbnailInfo"
              />
            </template>
          </navigation-cell-wrapper>
        </template>
      </div>
    </div>
    <template v-if="cellList.length === 0">
      <div class="empty_list">
        <img src="../../../assets/images/search/icon-error-74.png" alt="에러 아이콘"/>
        <p>채널이 없어요.</p>
      </div>
    </template>
    </div>
  </div>
</template>
<script>
  import { apiRequest, applyQueryString } from '@/common/utils/request.common'
  import Vue from 'vue'
  import _ from 'lodash'
  import ListViewMixin from '@/mixins/listview.mixin'
  import CircleCell from '@/components/model/cell/CircleCell'
  import LandscapeCell from '@/components/model/cell/LandscapeCell'
  import LandscapePlayerCell from '@/components/model/cell/LandscapePlayerCell'
  import PortraitCell from '@/components/model/cell/PortraitCell'
  import FilterList from '@/pages/list/FilterList'
  import { EVENT_TYPE_MOUSE_ENTER, EVENT_TYPE_MOUSE_LEAVE } from '@/common/resources/const'
  import fp from 'lodash/fp'
  import { getSectionEventObject } from '@/common/utils/gnb.fp'
  import { parseUrl } from 'query-string'
  import EmptyList from '@/pages/list/EmptyList'
  import { HTTP_METHOD_GET } from '@/common/utils/request.const'
  import canAutoPlay from 'can-autoplay'
  import { onDisplay } from '@/common/resources/directives'
  import { isAdultContent } from '@/common/utils/adult'
  import { getUser } from '@/common/utils/request'
  import cookie from '@/common/utils/cookie'
  import NavigationCellWrapper from '@/components/model/cellWrapper/NavigationCellWrapper'

  export default {
    name: 'TemplateLiveChannelList',
    components: {
      CircleCell,
      LandscapeCell,
      LandscapePlayerCell,
      PortraitCell,
      FilterList,
      EmptyList,
      NavigationCellWrapper
    },
    directives: {
      onDisplay
    },
    props: {
      sectionInfo: {
        type: Object
      },
      thumbnailInfo: {
        type: Object
      }
    },
    mixins: [ListViewMixin],
    data () {
      return {
        isLoading: false,
        isPlayerMute: true,
        firedEventMap: {},
        url: '',
        query: null,
        $liveGnbEvents: null,
        adultVerification: ''
      }
    },
    computed: {
      MUTE_STATE_KEY () {
        return this.$route.name + '_player_mute'
      },
      isLandscapePlayerCell () {
        return this.thumbnailInfo.componentName === 'landscape-player-cell'
      }
    },
    methods: {
      getOnContent () {
        const { onContent } = fp.flow(
          fp.getOr([], 'eventlist'),
          getSectionEventObject
        )(this.sectionInfo)
        return onContent
      },
      updateQuery () {
        this.setFilterQuery()
      },
      setFilterQuery () {
        const urlQuery = _.get(this.$route, 'query', {})
        this.query = _.assign({}, this.query, urlQuery)
      },
      setCellListForLivePlayer (data) {
        const cellList = _.get(data, ['cell_toplist', 'celllist'], [])
        let rows = []
        let cols = []
        for (let i = 0, len = cellList.length; i < len; i++) {
          if (i % 5 === 0) {
            if (cols.length > 0) {
              rows.push(cols)
            }
            cols = []
            cols.push(cellList[i])
            if (i === len - 1) {
              rows.push(cols)
            }
          } else {
            cols.push(cellList[i])
            if (i === len - 1) {
              rows.push(cols)
            }
          }
        }
        this.cellList = rows
        return data
      },
      setData () {
        if (this.cellList.length !== 0) return
        this.isLoading = true
        const assignedQuery = Object.assign({}, this.query)
        delete assignedQuery.api
        const req = { url: applyQueryString(`https://${this.url}`, assignedQuery), method: HTTP_METHOD_GET }
        apiRequest(req)
          .then(this.getData)
          .then(this.setTitle)
          .then(this.setFilter)
          .then(this.setCellType)
          .then(this.clearCellList)
          .then(this.setCellListForLivePlayer)
          .then(() => {
            this.isLoading = false
          })
      },
      clearAlreadyFiredEvent (channelId) {
        const keyList = Object.keys(this.firedEventMap)
        keyList.forEach((key) => {
          if (channelId !== key) {
            clearTimeout(this.firedEventMap[key].timer)
            setTimeout(() => {
              if (this.firedEventMap[key]) {
                this.firedEventMap[key].context.disableVideoMode()
                this.firedEventMap[key].context = null
                delete this.firedEventMap[key]
              }
            }, 0)
          }
        })
      },
      fireVideoInitEvent (channelId, context) {
        this.firedEventMap[channelId] = {
          timer: setTimeout(() => {
            canAutoPlay.video().then(({ result }) => {
              if (!result) {
                sessionStorage.setItem(this.MUTE_STATE_KEY, 'true')
                this.isPlayerMute = true
              }
              if (isAdultContent(context.targetAge)) {
                if (this.adultVerification === '' || cookie.getItem('adult-settings') !== 'N') {
                  context.blockPlayer()
                } else {
                  context.doPlay()
                }
              } else {
                context.doPlay()
              }
            }).catch(() => {
              context.blockPlayer()
            })
          }, 1000),
          context: context
        }
      },
      startPlayerInit (context) {
        const channelId = _.get(context, 'channelId', '')
        this.clearAlreadyFiredEvent(channelId, context)
        this.fireVideoInitEvent(channelId, context)
      },
      disposePlayer () {
        this.clearAlreadyFiredEvent('EMPTY')
      },
      setPlayerMuteState (state) {
        sessionStorage.setItem(this.MUTE_STATE_KEY, String(state))
        this.isPlayerMute = sessionStorage.getItem(this.MUTE_STATE_KEY) === 'true'
      },
      getMuteState () {
        const isMute = sessionStorage.getItem(this.MUTE_STATE_KEY)
        if (isMute === null) {
          sessionStorage.setItem(this.MUTE_STATE_KEY, 'true')
        }
        return sessionStorage.getItem(this.MUTE_STATE_KEY) === 'true'
      },
      initialize () {
        getUser().then(({ data }) => {
          this.adultVerification = _.defaultTo(_.get(data, 'adultverification', ''), '')
        })
        const onContent = this.getOnContent()
        const { url, query } = parseUrl(_.get(onContent, 'url', ''))
        this.isPlayerMute = this.getMuteState()
        this.url = url
        this.query = query
        this.updateQuery()
        this.setData()
      }
    },
    created () {
      this.initialize()
      Vue.prototype.$liveGnbEvents = new Vue()
      this.$liveGnbEvents.$on(EVENT_TYPE_MOUSE_ENTER, this.startPlayerInit)
      this.$liveGnbEvents.$on(EVENT_TYPE_MOUSE_LEAVE, this.disposePlayer)
    },
    beforeDestroy () {
      this.$liveGnbEvents.$off(EVENT_TYPE_MOUSE_ENTER, this.startPlayerInit)
      this.$liveGnbEvents.$off(EVENT_TYPE_MOUSE_LEAVE, this.disposePlayer)
    }
  }

</script>
<style lang="css" scoped>
  .list-view,
  .list-sub-menu{
    margin-top: 0;
  }

  .list-view-detail{
    width: auto;
  }

  .live-ui,
  .live-ui.expand,
  .live-ui .landscape:hover,
  .live-ui .landscape:hover .thumb-image {
    -webkit-transition: all 0.25s linear;
    -moz-transition: all 0.25s linear;
    transition: all 0.25s linear;
  }

  .live-ui .landscape,
  .live-ui .landscape .thumb-image {
    -webkit-transition: all 0.25s linear;
    -moz-transition: all 0.25s linear;
    transition: all 0.25s linear;
  }

  .live-ui {
    width: 1240px;
    margin: 0 auto 40px;
    text-align: left;
    font-size: 0;
  }

  .live-ui.expand {
    width: 1385px;
  }

  .empty_list {
    position: relative;
    width: 100%;
    height: 400px;
    margin-top: 200px;
    text-align: center;
  }

  .empty_list > p{
    margin-top: 12px;
    font-size: 18px;
    line-height: 1;
    color: #a5a5a5;
  }

  .empty_list img{
    width: 74px;
  }
</style>
